// extracted by mini-css-extract-plugin
export var page = "layout-module--page--1WJ7b";
export var header = "layout-module--header--UmhLx";
export var leftContainer = "layout-module--leftContainer--1PlDL";
export var rightContainer = "layout-module--rightContainer--3fXGc";
export var footer = "layout-module--footer--3iD_9";
export var wrapper = "layout-module--wrapper--Owhnb";
export var privacyPage = "layout-module--privacyPage--g1aLx";
export var appName = "layout-module--appName--2wSzd";
export var text = "layout-module--text--193Or";